<template>
  <fragment>
    <div>
      <div class="wraper not-found-page">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
        </div>
        <div class="container-fluid mycontainer-fluid  content_table">
            <div class="container">
              <div class="content__wrapper content__wrapper--centered">
                <div class="error-container">
                  <div class="error-container__img error-container__img--500"></div>
                  <div class="error-container__description">
                    <div class="error-title">Ошибка сервера</div>
                    <div class="error-subtitle">Внутренний сбой или ошибка в работе серверного приложения.</div>
                    <div class="error-subtitle">Обратитесь к вашему системному администратору или вернитесь на <a href="/regions" class="link link--error">главную страницу</a></div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- wraper -->
    </div>
    <slot name="footer"></slot>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_IS_VIEW_ALL_EXPERTISE, SET_MAIN_MENU } from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "Support",
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          /*if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }*/
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name: "Мои проекты",
          route: "Projects"
        }
      ]);
    }
  }
};
</script>
